import { useContext } from 'react';
import AppContext from '../app/context/AppContext';

// FUTURE: Consider using multiple context
const useAppContext = () => {
  return useContext(AppContext);
};

export default useAppContext;
